"use client";

import { ToastContainer as ToastContainerSlate } from "@faire/slate/components/toast";
import { ToastContainer as DeprecatedToastContainerSlate } from "@faire/web/slate/Toast/ToastContainer";
import React from "react";
import type { ToastContainerProps } from "react-toastify";

export const ToastContainer = (props: ToastContainerProps) => {
  return (
    <>
      <ToastContainerSlate />
      <DeprecatedToastContainerSlate {...props} />
    </>
  );
};
